import styles from "./Spinner.module.scss";
import {Oval} from "react-loader-spinner";
import React from "react";

const Spinner= () => {
    return (
        <div className={styles.wrapper}>
            <Oval
                visible={true}
                height="80"
                width="80"
                color="#4E72E6"
                secondaryColor="#4E72E6"
                ariaLabel="oval-loading"
            />
        </div>
    )
}

export default Spinner;